<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data() {
    return {
      cdata: {
        category: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8"
        ],
        lineData1: [
          8092,
          2028,
          5445,
          2848,
          5208,
          5697,
          4967,
          3415,
          2844,
          3015,
          4661,
          5277,
          6921,
          6760,
          4892
        ],
        lineData2: [
          1892,
          2028,
          2445,
          2848,
          3208,
          3697,
          3967,
          4415,
          4844,
          5015,
          5661,
          6277,
          5921,
          6760,
          1892
        ],
        lineData3: [
          4600,
          5000,
          5500,
          6500,
          7500,
          8500,
          9900,
          1500,
          1000,
          2500,
          2200,
          2450,
          2250,
          3300,
          400
        ],
        rateData: []
      },
      data: [
        {
          lineData1: [
            8092,
            6028,
            2445,
            3848,
            5208,
            5697,
            4967,
            5415,
            5844,
            4015,
            5661,
            7277,
            4921,
            5760,
            6892
          ],
          lineData2: [
            1892,
            2028,
            2745,
            2348,
            4208,
            2697,
            3067,
            3415,
            4044,
            4015,
            5061,
            3277,
            6921,
            5760,
            3892
          ],
          lineData3: [
            8092,
            2028,
            5445,
            2848,
            5208,
            5697,
            4967,
            3415,
            2844,
            3015,
            4661,
            5277,
            6921,
            6760,
            4892
          ]
        },
        {
          lineData2: [
            8092,
            2028,
            5445,
            2848,
            5208,
            5697,
            4967,
            3415,
            2844,
            3015,
            4661,
            5277,
            6921,
            6760,
            4892
          ],
          lineData3: [
            1892,
            2028,
            2445,
            2848,
            3208,
            3697,
            3967,
            4415,
            4844,
            5015,
            5661,
            6277,
            5921,
            6760,
            1892
          ],
          lineData1: [
            4600,
            5000,
            5500,
            6500,
            7500,
            8500,
            9900,
            1500,
            1000,
            2500,
            2200,
            2450,
            2250,
            3300,
            400
          ]
        },
        {
          lineData3: [
            8092,
            2028,
            5445,
            2848,
            5208,
            5697,
            4967,
            3415,
            2844,
            3015,
            4661,
            5277,
            6921,
            6760,
            4892
          ],
          lineData2: [
            1892,
            2028,
            2445,
            2848,
            3208,
            3697,
            3967,
            4415,
            4844,
            5015,
            5661,
            6277,
            5921,
            6760,
            1892
          ],
          lineData1: [
            4600,
            5000,
            5500,
            6500,
            7500,
            8500,
            9900,
            1500,
            1000,
            2500,
            2200,
            2450,
            2250,
            3300,
            400
          ]
        }
      ]
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.title = 'device 中中'
    // this.changeData(this.data)
  },
  methods: {
    changeData(data, timeout = 3000) {
      if (this.title) {
        // console.log(this.title, this.index)
      }
      let index = this.index >= data.length ? 0 : this.index
      // 更新数据
      this.cdata.lineData1 = this.data[index].lineData1
      this.cdata.lineData2 = this.data[index].lineData2
      this.cdata.lineData3 = this.data[index].lineData3

      index ++
      this.index = index
      this.timeoutIndex = setTimeout(() => {
        this.changeData(data)
      }, timeout)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>